const collapsableWindowStyles = {
  paper: {
    bottom: "1rem",
    display: "flex",
    flexDirection: "column",
    left: { xs: "1rem", sm: "auto" },
    overflow: "hidden",
    position: "fixed",
    right: { xs: "1rem", sm: "5rem" },
    zIndex: "1300",
  },
};

export default collapsableWindowStyles;
